import script from "./FieldControlPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./FieldControlPassword.vue?vue&type=script&lang=ts&setup=true"

import "./FieldControlPassword.vue?vue&type=style&index=0&id=4c0a3880&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0a3880"]])

export default __exports__